import { WebphoneCallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { InboxContext } from '../types';
import { TaskState } from '@modules/TasksModule/types';
import { setOutboundCallToRejected } from '../callHandlers/outboundCalls';

/** 
    A special handler to deal with the failed internal outbound calls.
    This handler is used to clear up any dangling outbound tasks after the 
    call failed event is received. This is important because the call failed event 
    can be received after the pcsConversation is fetched and the task is created.

    In addition to this, we have primary handler on the softphone to display a toast
    to inform the user about the failure.

    Here the callId is actually the remoteCallId and only id that is available
    with this softphone event.
*/
function handleCallFailed(_context: InboxContext, event: WebphoneCallEvent) {
  const task = TasksModule.findOutboundCallTaskByRemoteCallId(event.callId);

  // this is only going to be used for offered outbound calls
  if (!task || task.state !== TaskState.Offered) {
    return;
  }

  setOutboundCallToRejected(_context, task.id);
}

export default handleCallFailed;
